import { AnscNotificationsMutationCrumbs } from 'mutation/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import AnscNotificationsShared from 'shell/components/shared/ansc-notifications/list';
import { IdAmbito } from 'shell/constants/id-ambito';

const AnscNotificationsPage = (): ReactElement => {
  return (
    <Fragment>
      <AnscNotificationsShared scope={IdAmbito.Mutazioni} items={AnscNotificationsMutationCrumbs} />
    </Fragment>
  );
};

AnscNotificationsPage.displayName = 'Ansc Notification page component';

export default AnscNotificationsPage;
